<script>
import "@vueform/multiselect/themes/default.css";
import "flatpickr/dist/flatpickr.css";
import Swal from "sweetalert2";

import Layout from "../../../layouts/main.vue";
import appConfig from "../../../../app.config";
import PageHeader from "@/components/page-header";
import Axios from "@/config/axios";
import animationData from "@/components/widgets/msoeawqm.json";
import Lottie from "@/components/widgets/lottie.vue";

export default {
  page: {
    title: "Gestion des FAQ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      title: "Gestion des FAQ",
      items: [
        {
          text: "Ecommerce",
          href: "/",
        },
        {
          text: "Gestion des FAQ",
          active: true,
        },
      ],
      page: 1,
      perPage: 8,
      pages: [],
      value: null,
      statusquestion: "All",
      value1: null,
      searchQuery: null,
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "M j, Y",
        altInput: true,
        dateFormat: "d M, Y",
        mode: "range",
      },
      timeConfig: {
        enableTime: false,
        dateFormat: "d M, Y",
      },
      date: null,
      date2: null,
      defaultOptions: {
        animationData: animationData,
      },
      questions: [],
      isStatus: null,
      isPayment: null,
    };
  },
  components: {
    Layout,
    PageHeader,
    lottie: Lottie,
  },
  created() {},
  filters: {
    trimWords(value) {
      return value.split(" ").splice(0, 20).join(" ") + "...";
    },
  },

  mounted() {
    var checkAll = document.getElementById("checkAll");
    if (checkAll) {
      checkAll.onclick = function () {
        var checkboxes = document.querySelectorAll(
          '.form-check-all input[type="checkbox"]'
        );
        if (checkAll.checked == true) {
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = true;
            checkbox.closest("tr").classList.add("table-active");
          });
        } else {
          checkboxes.forEach(function (checkbox) {
            checkbox.checked = false;
            checkbox.closest("tr").classList.remove("table-active");
          });
        }
      };
    }
  },
  async beforeRouteEnter() {
    let questions = [];

    await Axios.get("/admin/faq-questions")
      .then(({ data }) => {
        questions = data.data;
      })
      .catch((er) => {
        console.log(er);
      });

    localStorage.setItem("@QUESTIONS_LIST", JSON.stringify(questions));
  },
  beforeMount() {
    this.questions = JSON.parse(
      localStorage.getItem("@QUESTIONS_LIST") || "[]"
    );
  },
  methods: {
    async getquestions() {
      await Axios.get("/admin/faq-questions")
        .then(({ data }) => {
          this.questions = data.data;
        })
        .catch((er) => {
          console.log(er);
        });
    },
    editdata(data) {
      let result = this.questions.findIndex(
        (o) => o.questionId == data.questionId
      );
      document.getElementById("edtquestionId").value =
        this.questions[result].id;

      document.getElementById("editquestion").value =
        this.questions[result].question;
      document.getElementById("editanswer").value =
        this.questions[result].answer;
    },
    updatequestion() {
      let result = this.questions.findIndex(
        (o) => o.id == document.getElementById("edtquestionId").value
      );
      this.questions[result].question =
        document.getElementById("editquestion").value;
      this.questions[result].answer =
        document.getElementById("editanswer").value;

      document.getElementById("edtclosemodal").click();

      Axios.put(
        `/admin/faq-questions/${
          document.getElementById("edtquestionId").value
        }`,
        this.questions[result]
      )
        .then(() => {
          this.getquestions();
        })
        .catch((er) => {
          console.log(er);
        });
    },
    createquestion() {
      const question = document.getElementById("createquestion").value;
      const answer = document.getElementById("createanswer").value;

      document.getElementById("createclosemodal").click();

      Axios.post(`/admin/faq-questions`, { question, answer })
        .then(() => {
          this.getquestions();
          document.getElementById("createquestion").value = "";
          document.getElementById("createanswer").value = "";
        })
        .catch((er) => {
          console.log(er);
        });
    },
    deletedata(event) {
      Swal.fire({
        title: "Êtes-vous certain ?",
        text: "Cette opération est irréversible !",
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: "Oui, supprimer !",
      }).then((result) => {
        if (result.value) {
          this.questions.splice(this.questions.indexOf(event), 1);
          Axios.delete(`/admin/faq-questions/${event.id}`)
            .then(() => {
              this.getquestions();
            })
            .catch((er) => {
              console.log(er);
            });
          Swal.fire("Supprimé !", "La question a été effacée.", "success");
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card" id="orderList">
          <div class="card-header border-0">
            <div class="d-flex align-items-center">
              <h5 class="card-title mb-0 flex-grow-1">FAQ de produits</h5>
              <div class="flex-shrink-0">
                <button
                  type="button"
                  class="btn btn-success add-btn"
                  data-bs-toggle="modal"
                  id="create-btn"
                  data-bs-target="#showModal"
                >
                  <i class="ri-add-line align-bottom me-1"></i> Creer une
                  question
                </button>
                <!-- <button type="button" class="btn btn-info ms-1">
                  <i class="ri-file-download-line align-bottom me-1"></i> Importer
                </button> -->
              </div>
            </div>
          </div>
          <div
            class="card-body pt-4 border border-dashed border-end-0 border-start-0"
          >
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                    <tr class="text-uppercase">
                      <th scope="col" style="width: 25px">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            id="checkAll"
                            value="option"
                          />
                        </div>
                      </th>
                      <th class="sort" data-sort="id">ID question</th>
                      <th class="sort" data-sort="customer_name">Question</th>
                      <th class="sort" data-sort="product_name">Réponse</th>
                      <th class="sort" data-sort="city">Actions</th>
                    </tr>
                  </thead>
                  <tbody
                    class="list form-check-all"
                    v-for="(item, index) of questions"
                    :key="index"
                  >
                    <tr>
                      <th scope="row">
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            name="chk_child"
                            value="option1"
                          />
                        </div>
                      </th>
                      <td class="id">
                        {{ item.id }}
                      </td>
                      <td class="customer_name">{{ item.question }}</td>
                      <td class="amount">{{ item.answer }}</td>
                      <td>
                        <ul class="list-inline hstack gap-2 mb-0">
                          <li
                            class="list-inline-item edit"
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-placement="top"
                            title="Edit"
                          >
                            <a
                              class="text-primary d-inline-block edit-item-btn"
                              data-bs-toggle="modal"
                              href="#EditModal"
                              @click="editdata(item)"
                            >
                              <i class="ri-pencil-fill fs-16"></i>
                            </a>
                          </li>
                          <li
                            class="list-inline-item"
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-placement="top"
                            title="Remove"
                          >
                            <a
                              class="text-danger d-inline-block remove-item-btn"
                              @click="deletedata(item)"
                            >
                              <i class="ri-delete-bin-5-fill fs-16"></i>
                            </a>
                          </li>
                        </ul>
                      </td>
                      <!-- </div> -->
                    </tr>
                  </tbody>
                </table>
                <div class="noresult" style="display: none">
                  <div class="text-center">
                    <lottie
                      class="avatar-xl"
                      colors="primary:#121331,secondary:#08a88a"
                      :options="defaultOptions"
                      :height="75"
                      :width="75"
                    />
                    <h5 class="mt-2">Pardon! Aucun résultat trouvé</h5>
                    <p class="text-muted">
                      Nous avons recherché plus de 150 commandes Nous n'en avons
                      trouvé aucune commandes pour votre recherche.
                    </p>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <div class="pagination-wrap hstack gap-2">
                  <a
                    class="page-item pagination-prev disabled"
                    href="#"
                    v-if="page != 1"
                    @click="page--"
                  >
                    Precedent
                  </a>
                  <ul class="pagination listjs-pagination mb-0">
                    <li
                      v-for="(pageNumber, index) in pages.slice(
                        page - 1,
                        page + 5
                      )"
                      :key="index"
                      @click="page = pageNumber"
                      :class="{
                        active: pageNumber == page,
                        disabled: pageNumber == '...',
                      }"
                    >
                      <a class="page" href="#">{{ pageNumber }}</a>
                    </li>
                  </ul>
                  <a
                    class="page-item pagination-next"
                    href="#"
                    @click="page++"
                    v-if="page < pages.length"
                  >
                    Suivant
                  </a>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="showModal"
              tabindex="-1"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-light p-3">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Ajouter une question
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-modal"
                    ></button>
                  </div>
                  <form action="#" id="createform">
                    <div class="modal-body">
                      <input type="hidden" id="id-field" />

                      <div class="mb-4">
                        <label for="delivered-status" class="form-label"
                          >Question</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          data-trigger
                          name="delivered-status"
                          id="createquestion"
                        />
                      </div>

                      <div>
                        <label for="delivered-status" class="form-label"
                          >Réponse</label
                        >
                        <textarea
                          class="form-control"
                          type="text"
                          rows="7"
                          data-trigger
                          id="createanswer"
                        ></textarea>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-bs-dismiss="modal"
                          id="createclosemodal"
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          id="add-btn"
                          @click="createquestion"
                        >
                          Enregistrer
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="EditModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabels"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                  <div class="modal-header bg-light p-3">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Editer une question
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      id="close-modal"
                    ></button>
                  </div>
                  <form action="#" id="editform">
                    <div class="modal-body">
                      <input type="hidden" id="id-field" />

                      <div class="mb-3 d-none" id="modal-id">
                        <label for="questionId" class="form-label">ID</label>
                        <input
                          type="text"
                          pattern="\d*"
                          id="edtquestionId"
                          class="form-control"
                          placeholder="ID"
                          maxlength="3"
                          readonly
                        />
                      </div>

                      <div class="mb-4">
                        <label for="delivered-status" class="form-label"
                          >Question</label
                        >
                        <input
                          class="form-control"
                          type="text"
                          data-trigger
                          name="delivered-status"
                          id="editquestion"
                        />
                      </div>

                      <div>
                        <label for="delivered-status" class="form-label"
                          >Réponse</label
                        >
                        <textarea
                          class="form-control"
                          type="text"
                          rows="7"
                          data-trigger
                          id="editanswer"
                        ></textarea>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <div class="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          class="btn btn-light"
                          data-bs-dismiss="modal"
                          id="edtclosemodal"
                        >
                          Fermer
                        </button>
                        <button
                          type="button"
                          class="btn btn-success"
                          id="add-btn"
                          @click="updatequestion"
                        >
                          Modifier
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end col-->
    </div>
    <!--end row-->
  </Layout>
</template>
